<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-20 11:11:33
-->
<template>
  <div>
    <div v-if="row.avatar_url" class="flex-row flex-align-center">
      <yx-avatar :size="40" :src="row.avatar_url"></yx-avatar>
      <div class="ml-8">
        <div v-if="row.nickname">微信昵称: {{row.nickname}}</div>
        <div v-if="row.wechat_account">微信号: {{row.wechat_account}}</div>
      </div>
    </div>
    <div v-else-if="row.wechat_account">微信号: {{row.wechat_account}}</div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin],
  components: {
   
  }
}
</script>